export default __webpack_public_path__ + "static/media/libros.adda4a74.jpg";